import PropTypes from 'prop-types';

const devicePropType = PropTypes.shape({
  isDiscovered: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  macAddress: PropTypes.string.isRequired,
  serialNumber: PropTypes.string.isRequired,
  ipAddress: PropTypes.string,
  lastDiscovered: PropTypes.number,
  firmwareVersion: PropTypes.string,
  source: PropTypes.string.isRequired,
});

const sensorMetaDataPropType = PropTypes.shape({
  channelGroupIndex: PropTypes.number,
  channelGroupTypeId: PropTypes.string,
  label: PropTypes.string,
});

const deviceListContextPropType = PropTypes.shape({
  deviceList: PropTypes.arrayOf(PropTypes.object).isRequired,
  findAll: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
});

export {
  deviceListContextPropType,
  sensorMetaDataPropType,
  devicePropType,
};
